import { ListUtilities } from 'src/utilities/listUtilities';
import {
  IKameleoonData,
  KameleoonData,
  VisitDataType,
  VisitsDataType,
} from './types';
import { TrackingStatus } from 'src/types';

/**
 * @class
 * Visits - a class for creating an instance of a stored visits data
 * */
export class VisitsData implements IKameleoonData {
  // --- Note ---
  // Ascending order
  private visits: VisitDataType[];
  private visitNumber: number;
  public status: TrackingStatus = TrackingStatus.Sent;

  /**
   * @param {number[]} visits - a list of visits
   * */
  constructor(visits: VisitDataType[]) {
    this.visits = visits;
    this.visitNumber = visits.length ? visits.length - 1 : 0;
  }

  get url(): string {
    return '';
  }

  get data(): VisitsDataType {
    return {
      visits: this.visits,
      visitNumber: this.visitNumber,
      type: KameleoonData.VisitsData,
      status: this.status,
    };
  }

  get isSent(): boolean {
    return true;
  }

  /**
   * Adds a single timestamp while ensuring the list remains sorted and unique
   * @param {VisitDataType} visit - The visit data to be added
   */
  set timestamp(visit: VisitDataType) {
    ListUtilities.insertVisitInOrderedListMutably({
      list: this.visits,
      visit,
    });

    this.visitNumber = this.visits.length ? this.visits.length - 1 : 0;
  }

  public updateVisitNumber(visitNumber: number): void {
    if (visitNumber > this.visitNumber) {
      this.visitNumber = visitNumber;
    }
  }
}
